const ORDER_STATUS = {
  PROCESSING: 'Processing',
  DISPATCH: 'Dispatch',
  PICK: 'Pick',
  TRANSIT: 'Transit',
  ATTENTE: 'Attente',
  DROP: 'Drop',
  TERMINEE: 'Terminée',
  TRANSFEREE: 'Transférée',
  REJECT: 'Reject',
  INSPECTION: 'Inspection',
  CANCEL: 'Cancel',
  TO_CANCEL: 'to cancel',
  TO_FINISH: 'to finish',
  IS_BILLING: 'isBilling'
}

const ORDER_STATUS_LIST = Object.values(ORDER_STATUS)

const ORDER_STATUS_COLORS = {
  [ORDER_STATUS.PROCESSING]: {
    bg: '#3B82F6',
    text: '#ffffff',
    icon: 'fa-cog',
    label: 'Processing'
  },
  [ORDER_STATUS.DISPATCH]: {
    bg: '#6366F1',
    text: '#ffffff',
    icon: 'fa-paper-plane',
    label: 'Dispatch'
  },
  [ORDER_STATUS.PICK]: {
    bg: '#06B6D4',
    text: '#ffffff',
    icon: 'fa-box',
    label: 'Pick'
  },
  [ORDER_STATUS.TRANSIT]: {
    bg: '#8B5CF6',
    text: '#ffffff',
    icon: 'fa-truck',
    label: 'Transit'
  },
  [ORDER_STATUS.ATTENTE]: {
    bg: '#F59E0B',
    text: '#ffffff',
    icon: 'fa-clock-o',
    label: 'Waiting'
  },
  [ORDER_STATUS.DROP]: {
    bg: '#10B981',
    text: '#ffffff',
    icon: 'fa-check-circle',
    label: 'Delivered'
  },
  [ORDER_STATUS.TERMINEE]: {
    bg: '#059669',
    text: '#ffffff',
    icon: 'fa-check-square',
    label: 'Finished'
  },
  [ORDER_STATUS.TRANSFEREE]: {
    bg: '#0EA5E9',
    text: '#ffffff',
    icon: 'fa-exchange',
    label: 'Transferred'
  },
  [ORDER_STATUS.REJECT]: {
    bg: '#EF4444',
    text: '#ffffff',
    icon: 'fa-times-circle',
    label: 'Rejected'
  },
  [ORDER_STATUS.INSPECTION]: {
    bg: '#F97316',
    text: '#ffffff',
    icon: 'fa-search',
    label: 'Inspection'
  },
  [ORDER_STATUS.CANCEL]: {
    bg: '#6B7280',
    text: '#ffffff',
    icon: 'fa-ban',
    label: 'Canceled'
  },
  [ORDER_STATUS.IS_BILLING]: {
    bg: '#059669',
    text: '#ffffff',
    icon: 'fa-file-invoice-dollar',
    label: 'To Bill'
  }
}

const ACTIVE_STATUSES = [
  ORDER_STATUS.PROCESSING,
  ORDER_STATUS.DISPATCH,
  ORDER_STATUS.PICK,
  ORDER_STATUS.TRANSIT
]

const WARNING_STATUSES = [
  ORDER_STATUS.PROCESSING,
  ORDER_STATUS.REJECT,
  ORDER_STATUS.ATTENTE,
  ORDER_STATUS.TRANSIT
]

const CURRENT_ORDER_STATUSES = [
  ORDER_STATUS.PROCESSING,
  ORDER_STATUS.DISPATCH,
  ORDER_STATUS.PICK,
  ORDER_STATUS.TRANSIT,
  ORDER_STATUS.REJECT,
  ORDER_STATUS.INSPECTION,
  ORDER_STATUS.TRANSFEREE
]

const DELIVERED_ORDER_STATUSES = [
  ORDER_STATUS.DROP,
  ORDER_STATUS.TERMINEE
]

const VEHICLE_SIZES = {
  LIGHT: { id: 2, name: 'light', label: 'Light' },
  MEDIUM: { id: 3, name: 'medium', label: 'Medium' },
  HEAVY: { id: 4, name: 'heavy', label: 'Heavy' },
  EXTRA_HEAVY: { id: 5, name: 'extra_heavy', label: 'Extra Heavy' },
  NOT_STANDARD: { id: 1, name: 'not_standard', label: 'Not Standard' }
}

function getVehicleSizeById (id) {
  for (const size of Object.values(VEHICLE_SIZES)) {
    if (size.id === id) return size.name
  }
  return 'not_standard'
}

function getVehicleSizeLabel (name) {
  for (const size of Object.values(VEHICLE_SIZES)) {
    if (size.name === name) return size.label
  }
  return 'Not Standard'
}

function getStatusConfig (status) {
  return ORDER_STATUS_COLORS[status] || {
    bg: '#9CA3AF',
    text: '#ffffff',
    icon: 'fa-question',
    label: status || 'Unknown'
  }
}

function isWarningOrder (order) {
  if (!order.status) return false
  if (!order.warningTime) return false
  const currentDate = Date.now()
  return WARNING_STATUSES.includes(order.status) && currentDate >= order.warningTime
}

function isLateOrder (order) {
  if (!order.status) return false
  if (!order.lateTime) return false
  const currentDate = Date.now()
  return WARNING_STATUSES.includes(order.status) && currentDate >= order.lateTime
}

export {
  ORDER_STATUS,
  ORDER_STATUS_LIST,
  ORDER_STATUS_COLORS,
  ACTIVE_STATUSES,
  WARNING_STATUSES,
  CURRENT_ORDER_STATUSES,
  DELIVERED_ORDER_STATUSES,
  VEHICLE_SIZES,
  getVehicleSizeById,
  getVehicleSizeLabel,
  getStatusConfig,
  isWarningOrder,
  isLateOrder
}
